import React from 'react';
import { getBasePath } from '../global/helpers/routing';
import { LabelAndValue } from '../global/components/data-display/label-value';
import { DividerSection } from '../global/components/layout/divider-section';
import { AuthSetting } from '../global/constants/auth-settings';
import { PageHeader } from '../global/components/layout/page-header';
import { ApiEndpoint } from '../global/constants/api-endpoints';

interface Props {
	contentId: string;
	language: string;
	availableLanguages: string[];
}
export function TcsmEnvironment(props: Props) {

	const { availableLanguages } = props;
	const basePath = getBasePath(props.language);

	const containerStyle = {
		margin: '1em 2em',
	};

	function RenderLanguages() {
		if (availableLanguages?.length > 0) {
			return (
				<DividerSection removeDivider sectionText='Available Languages'>
					{availableLanguages.map((l, index) => <LabelAndValue label={`Language ${index}`} value={l} />)}
				</DividerSection>
			);
		}
	}

	function RenderEndpointsSettings() {
		return (
			<DividerSection removeDivider sectionText='API Endpoints'>
				<LabelAndValue label="personPrc" value={ApiEndpoint.personPrc} />
				<LabelAndValue label="organizationPrc" value={ApiEndpoint.organizationPrc} />
				<LabelAndValue label="benAdmin" value={ApiEndpoint.benAdmin} />
				<LabelAndValue label="mlps" value={ApiEndpoint.mlps} />
				<LabelAndValue label="wam" value={ApiEndpoint.wam} />
				<LabelAndValue label="notification" value={ApiEndpoint.notification} />
				<LabelAndValue label="myCpgPod" value={ApiEndpoint.myCpgPod} />
			</DividerSection>
		);
	}

	function RenderAuthSettings() {
		return (
			<DividerSection removeDivider sectionText='Authorization Settings'>
				<LabelAndValue label="REACT_APP_AUDIENCE" value={AuthSetting.REACT_APP_AUDIENCE} />
				<LabelAndValue label="REACT_APP_DOMAIN" value={AuthSetting.REACT_APP_DOMAIN} />
				<LabelAndValue label="REACT_APP_AUTH0_LOGOUT_URL" value={AuthSetting.REACT_APP_AUTH0_LOGOUT_URL} />
				<LabelAndValue label="REACT_APP_MULESOFT_URL" value={AuthSetting.REACT_APP_MULESOFT_URL} />
				<LabelAndValue label="REACT_APP_SESSION_COUNTDOWN" value={AuthSetting.REACT_APP_SESSION_COUNTDOWN} />
				<LabelAndValue label="REACT_APP_SESSION_TIMEOUT" value={AuthSetting.REACT_APP_SESSION_TIMEOUT} />
				<LabelAndValue label="REACT_APP_SESSION_THROTTLE" value={AuthSetting.REACT_APP_SESSION_THROTTLE} />
			</DividerSection>
		);
	}

	return (
		<div style={containerStyle} >
			<PageHeader
				headerText='Environment information'
			/>
			<DividerSection removeDivider sectionText='Basic information'>
				<LabelAndValue label="Content Id" value={props.contentId} />
				<LabelAndValue label="Base path" value={basePath} />
			</DividerSection>
			<RenderLanguages />
			<RenderEndpointsSettings />
			<RenderAuthSettings />
		</div>
	);
}